var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrdersActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7166_199209)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.833 12.752L16.293 12.762C15.593 12.762 14.973 13.002 14.523 13.462C14.053 13.932 13.793 14.612 13.793 15.382L13.803 18.432C13.813 19.962 14.843 21.022 16.313 21.022L19.853 21.012C20.563 21.012 21.173 20.772 21.623 20.322C22.093 19.852 22.353 19.172 22.353 18.402L22.343 15.352C22.343 13.822 21.313 12.752 19.833 12.752Z",
    fill: "#1080FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.543 10.3224C14.993 10.7624 15.593 10.9924 16.293 10.9924H19.853C21.353 10.9824 22.353 9.93242 22.353 8.37242L22.343 5.58242C22.343 4.05242 21.313 2.98242 19.833 2.98242L16.293 2.99242C15.593 2.99242 14.983 3.23242 14.523 3.69242C14.053 4.16242 13.793 4.84242 13.793 5.61242L13.803 8.40242C13.813 9.17242 14.073 9.85242 14.543 10.3224Z",
    fill: "#1080FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.2695 16.7832H18.8695C19.2895 16.7832 19.6195 16.4533 19.6195 16.0332C19.6195 15.6232 19.2895 15.2832 18.8695 15.2832H17.2695C16.8595 15.2832 16.5195 15.6232 16.5195 16.0332C16.5195 16.4533 16.8595 16.7832 17.2695 16.7832Z",
    fill: "#1080FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8695 5.51172H17.2695C16.8595 5.51172 16.5195 5.85172 16.5195 6.26172C16.5195 6.68172 16.8595 7.01172 17.2695 7.01172H18.8695C19.2895 7.01172 19.6195 6.68172 19.6195 6.26172C19.6195 5.85172 19.2895 5.51172 18.8695 5.51172Z",
    fill: "#1080FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39156 5.96289H5.85156C5.11156 5.97289 4.48156 6.24289 4.04156 6.70289C3.60156 7.17289 3.35156 7.81289 3.35156 8.58289L3.36156 18.1929C3.36156 18.9629 3.62156 19.6429 4.09156 20.1129C4.54156 20.5529 5.15156 20.7829 5.84156 20.7829H9.41156C10.8816 20.7729 11.9116 19.6929 11.9016 18.1629V8.56289C11.9016 7.79289 11.6316 7.11289 11.1616 6.64289C10.7116 6.19289 10.0816 5.97289 9.39156 5.96289Z",
    fill: "#1080FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8.70119H8.36C8.77 8.70119 9.11 8.37117 9.11 7.95117C9.11 7.54117 8.77 7.20117 8.36 7.20117H6.75C6.34 7.20117 6 7.54117 6 7.95117C6 8.37117 6.34 8.70119 6.75 8.70119Z",
    fill: "#1080FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7166_199209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersActive);
export default __webpack_public_path__ + "static/media/orders_active.1ad75fa8a7e4b1fcc88580a9d236e88e.svg";
export { ForwardRef as ReactComponent };